import { configureOpenApiClients } from '../../api/configure';
import { deviationGetAll, deviationGetCritical } from '../../api/v1';

export const useDeviationApi = () => {
  configureOpenApiClients();

  const getAllDeviations = async () => await deviationGetAll();

  const getCriticalDeviations = async () => await deviationGetCritical();

  return {
    getAllDeviations,
    getCriticalDeviations,
  };
};
